export default __webpack_public_path__ + "static/media/22.01ef967d.jpg";